export enum LayoutVerticalPadding {
  SMALL = 'small',
  LARGE = 'large',
}

export enum LayoutSize {
  REGULAR = 'regular',
  SMALL = 'small',
}
